import type { PoolOverviewData } from '@/types/pool';
import { formatCurrency } from '@/utils/misc';
import { CreatePoolButton } from '../CreatePoolButton';
import { OverviewSection } from './OverviewSection';
import { StatCard } from './StatCard';

type BorrowerOverviewProps = {
  overviewStats: Partial<PoolOverviewData> | null;
  loading: boolean;
  onCreatePoolClick: () => void;
};

export default function BorrowerOverview({ overviewStats, loading, onCreatePoolClick }: BorrowerOverviewProps) {
  return (
    <OverviewSection title="Overview">
      {/* Overview Cards - Responsive Grid */}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
        <StatCard
          header="Amount Requested"
          mainText={formatCurrency(overviewStats?.total_borrowed)}
          description="(i) Total amount you've received across all funded pools."
          loading={loading}
        />

        <StatCard
          header="Funded Pools"
          mainText={overviewStats?.funded_pools?.toString() ?? '0'}
          description="(i) Number of your pool that are funded and are your active liabilities."
          loading={loading}
        />

        <StatCard
          header="Pools in process"
          mainText={overviewStats?.pools_in_process?.toString() ?? '0'}
          description="(i) Pool or offers still pending funding or final approval."
          loading={loading}
        />
      </div>

      <CreatePoolButton onClick={onCreatePoolClick} />
    </OverviewSection>
  );
}
